import { useHistory, useParams } from "react-router";
import { Tabs, Tag } from "antd";
import { useContext, useState } from "react";
import "../../project-setting-menu/module-settings/module-settings.scss";
import { SubscriptionContext } from "context/SubscriptionProvider";
import { FeatureTypes } from "entity-app/constants";
import FeatureSubscriptionSettings from "./feature-subscription-settings";
import DesignScopeSubscriptionSettings from "./design-scope-settings";

function ModuleSubscriptionSettings() {
  const history = useHistory();
  const { tab2Id } = useParams() as any;

  const { isFeatureFlagEnabled } = useContext(SubscriptionContext);
  const isBuyoutEnabled = isFeatureFlagEnabled("BUYOUT");

  // Honor a deep-linked tab. The design packages tab was removed, so that
  // URL falls back to the same default as a missing tab.
  const defaultTab = isBuyoutEnabled ? "designscope" : "materials";
  const [tabIndex, setTabIndex] = useState<string>(
    tab2Id && tab2Id !== "designpackages" ? tab2Id : defaultTab
  );
  const tabItems = [
    ...(isBuyoutEnabled
      ? [
          {
            label: (
              <span
                className="flex items-end space-x-1"
                data-testid="design-scope-tab"
              >
                <div> Design Scope</div>
                <Tag>Beta</Tag>
              </span>
            ),
            key: "designscope",
            children: <DesignScopeSubscriptionSettings />
          },
          {
            label: (
              <span
                className="flex items-end space-x-1"
                data-testid="bid-packages-tab"
              >
                <div> Bid Packages</div>
                <Tag>Beta</Tag>
              </span>
            ),
            key: "bidpackages",
            children: (
              <FeatureSubscriptionSettings
                featureId={FeatureTypes.BID_PACKAGE}
              />
            )
          }
        ]
      : []),
    {
      label: "Materials",
      key: "materials",
      children: (
        <FeatureSubscriptionSettings featureId={FeatureTypes.MATERIALS} />
      )
    }
  ];
  return (
    <div className="w-full py-1 h-full module-settings--parentTabs">
      <Tabs
        onChange={(activeKey) => {
          history.push(`/settings/modules/${activeKey.toString()}`);
          setTabIndex(activeKey);
        }}
        activeKey={tabIndex}
        items={tabItems}
        destroyOnHidden
        data-testid="index-tabs-module-settings"
      />
    </div>
  );
}
export default ModuleSubscriptionSettings;
